/* ============================================================
   WOAH HYDRATION — theme behaviour
   ============================================================ */
(function () {
  "use strict";

  var cfg = window.WoahTheme || {};
  var routes = cfg.routes || {};

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    var fmt = cfg.moneyFormat || "${{amount}}";
    // Support the common Shopify money placeholders; fall back to amount.
    if (fmt.indexOf("{{") === -1) return fmt + amount;
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (m, key) {
      if (key.indexOf("with_comma_separator") !== -1 || key.indexOf("no_decimals") === -1) {
        return withCommas(amount);
      }
      return withCommas((cents / 100).toFixed(0));
    });
  }
  function withCommas(num) {
    var parts = String(num).split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
  }

  /* ---------- toast ---------- */
  var toastEl = $("[data-toast]");
  var toastTimer;
  function toast(msg) {
    if (!toastEl) return;
    toastEl.textContent = msg;
    toastEl.classList.add("show");
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove("show"); }, 2600);
  }

  /* ---------- header scroll ---------- */
  var header = $("[data-header]");
  if (header) {
    var onScroll = function () { header.classList.toggle("scrolled", window.scrollY > 8); };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
  }

  /* ---------- mobile nav ---------- */
  var mobileNav = $("[data-mobile-nav]");
  function openMobile() { if (mobileNav) { mobileNav.classList.add("open"); document.body.classList.add("no-scroll"); } }
  function closeMobile() { if (mobileNav) { mobileNav.classList.remove("open"); document.body.classList.remove("no-scroll"); } }
  $all("[data-menu-open]").forEach(function (b) { b.addEventListener("click", openMobile); });
  $all("[data-menu-close]").forEach(function (b) { b.addEventListener("click", closeMobile); });
  if (mobileNav) $all("a.mn-link", mobileNav).forEach(function (a) { a.addEventListener("click", closeMobile); });

  /* ---------- overlay + cart drawer ---------- */
  var overlay = $("[data-overlay]");
  var drawer = $("[data-cart-drawer]");
  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add("open");
    if (overlay) overlay.classList.add("open");
    document.body.classList.add("no-scroll");
    refreshCart();
  }
  function closeDrawer() {
    if (drawer) drawer.classList.remove("open");
    if (overlay) overlay.classList.remove("open");
    document.body.classList.remove("no-scroll");
  }
  if (overlay) overlay.addEventListener("click", function () { closeDrawer(); closeMobile(); });
  $all("[data-cart-close]").forEach(function (b) { b.addEventListener("click", closeDrawer); });
  document.addEventListener("keyup", function (e) { if (e.key === "Escape") { closeDrawer(); closeMobile(); } });

  $all("[data-cart-open]").forEach(function (b) {
    b.addEventListener("click", function (e) {
      if (cfg.cartType === "page") return; // let the link navigate
      e.preventDefault();
      openDrawer();
    });
  });

  /* ---------- cart rendering ---------- */
  function setCartCount(count) {
    $all("[data-cart-count]").forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? "" : "none";
    });
  }

  function cartItemHTML(item) {
    var img = item.image
      ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?|$)/i, "_120x$1$2") + '" alt="' + escapeHtml(item.product_title) + '">'
      : "";
    var variant = item.variant_title && item.variant_title !== "Default Title" ? item.variant_title : "";
    return (
      '<div class="ci" data-line-key="' + item.key + '">' +
        '<div class="ci-thumb">' + img + "</div>" +
        '<div class="ci-info">' +
          "<h5>" + escapeHtml(item.product_title) + "</h5>" +
          (variant ? '<div class="ci-variant">' + escapeHtml(variant) + "</div>" : "") +
          '<div class="ci-price">' + formatMoney(item.final_line_price) + "</div>" +
          '<div class="ci-qty">' +
            '<button data-line-minus aria-label="Decrease">\u2212</button>' +
            "<span>" + item.quantity + "</span>" +
            '<button data-line-plus aria-label="Increase">+</button>' +
          "</div>" +
          '<button class="ci-remove" data-line-remove>Remove</button>' +
        "</div>" +
      "</div>"
    );
  }

  function escapeHtml(str) {
    return String(str == null ? "" : str)
      .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
  }

  function renderCart(cart) {
    setCartCount(cart.item_count);
    var itemsEl = $("[data-cart-items]");
    var footEl = $("[data-cart-foot]");
    var subEl = $("[data-cart-subtotal]");
    if (!itemsEl) return;
    if (cart.item_count === 0) {
      itemsEl.innerHTML =
        '<div class="cd-empty"><span class="big">Your bag is empty</span>Time to stock up on hydration.</div>';
      if (footEl) footEl.style.display = "none";
    } else {
      itemsEl.innerHTML = cart.items.map(cartItemHTML).join("");
      if (footEl) footEl.style.display = "";
      if (subEl) subEl.textContent = formatMoney(cart.total_price);
    }
  }

  function refreshCart() {
    return fetch(routes.cart + ".js", { headers: { "Content-Type": "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); return cart; })
      .catch(function () {});
  }

  function changeLine(key, quantity) {
    return fetch(routes.cartChange + ".js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: key, quantity: quantity }),
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); return cart; });
  }

  // Cart drawer line controls (delegated)
  if (drawer) {
    drawer.addEventListener("click", function (e) {
      var row = e.target.closest("[data-line-key]");
      if (!row) return;
      var key = row.getAttribute("data-line-key");
      var qtyEl = $(".ci-qty span", row);
      var qty = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
      if (e.target.closest("[data-line-plus]")) changeLine(key, qty + 1);
      else if (e.target.closest("[data-line-minus]")) changeLine(key, Math.max(0, qty - 1));
      else if (e.target.closest("[data-line-remove]")) changeLine(key, 0);
    });
  }

  /* ---------- add to cart forms ---------- */
  $all("[data-product-form]").forEach(function (form) {
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var btn = $("[data-add-btn]", form) || form.querySelector('[type="submit"]');
      var original = btn ? btn.innerHTML : "";
      if (btn) { btn.disabled = true; btn.innerHTML = "Adding\u2026"; }
      var data = new FormData(form);
      fetch(routes.cartAdd + ".js", {
        method: "POST",
        headers: { Accept: "application/json" },
        body: data,
      })
        .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
        .then(function (res) {
          if (!res.ok) {
            toast(res.body.description || res.body.message || "Could not add");
            return;
          }
          toast((cfg.strings && cfg.strings.added) || "Added to cart");
          return refreshCart().then(function () {
            if (cfg.cartType === "page") { window.location.href = routes.cart; }
            else openDrawer();
          });
        })
        .catch(function () { toast("Something went wrong"); })
        .finally(function () { if (btn) { btn.disabled = false; btn.innerHTML = original; } });
    });
  });

  /* ---------- quantity pickers ---------- */
  $all("[data-qty]").forEach(function (widget) {
    var input = $("input", widget);
    if (!input) return;
    $all("[data-qty-step]", widget).forEach(function (b) {
      b.addEventListener("click", function () {
        var step = parseInt(b.getAttribute("data-qty-step"), 10);
        var val = Math.max(1, (parseInt(input.value, 10) || 1) + step);
        input.value = val;
        input.dispatchEvent(new Event("change", { bubbles: true }));
      });
    });
  });

  /* ---------- product variant picker ---------- */
  $all("[data-variant-picker]").forEach(function (picker) {
    var form = picker.closest("[data-product-form]") || document;
    var idInput = $("[data-variant-id]", form);
    var priceEl = $("[data-price]", form);
    var swatches = $all("[data-variant]", picker);
    var variants = [];
    try { variants = JSON.parse(picker.getAttribute("data-variants") || "[]"); } catch (e) {}

    swatches.forEach(function (sw) {
      sw.addEventListener("click", function () {
        swatches.forEach(function (s) { s.classList.remove("active"); });
        sw.classList.add("active");
        var id = sw.getAttribute("data-variant");
        if (idInput) idInput.value = id;
        var v = variants.filter(function (x) { return String(x.id) === String(id); })[0];
        if (v && priceEl) priceEl.textContent = formatMoney(v.price);
        var addBtn = $("[data-add-btn]", form);
        if (v && addBtn) {
          addBtn.disabled = !v.available;
          addBtn.querySelector("[data-add-label]") &&
            (addBtn.querySelector("[data-add-label]").textContent =
              v.available ? addBtn.getAttribute("data-label-add") : (cfg.strings && cfg.strings.soldOut) || "Sold out");
        }
        var featured = v && v.featured_media;
        if (featured) selectMedia(String(featured.id));
      });
    });
  });

  /* ---------- product gallery ---------- */
  function selectMedia(id) {
    var main = $("[data-gallery-main]");
    var thumb = $('[data-media-thumb="' + id + '"]');
    if (!thumb || !main) return;
    var src = thumb.getAttribute("data-media-src");
    var imgEl = $("img", main);
    if (imgEl && src) imgEl.src = src;
    $all("[data-media-thumb]").forEach(function (t) { t.classList.remove("active"); });
    thumb.classList.add("active");
  }
  $all("[data-media-thumb]").forEach(function (t) {
    t.addEventListener("click", function () { selectMedia(t.getAttribute("data-media-thumb")); });
  });

  /* ---------- FAQ accordion ---------- */
  $all("[data-faq-q]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var item = btn.closest(".faq-item");
      var ans = $(".faq-a", item);
      var open = item.classList.toggle("open");
      if (ans) ans.style.maxHeight = open ? ans.scrollHeight + "px" : "0px";
    });
  });

  /* ---------- reveal on scroll ---------- */
  var revealEls = $all(".reveal");
  function revealAll() { revealEls.forEach(function (el) { el.classList.add("in"); }); }
  if ("IntersectionObserver" in window && revealEls.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add("in"); io.unobserve(en.target); }
      });
    }, { threshold: 0.08, rootMargin: "0px 0px -5% 0px" });
    revealEls.forEach(function (el) { io.observe(el); });
    setTimeout(revealAll, 1000);
  } else {
    revealAll();
  }

  /* ---------- demo signup forms (non-Shopify) ---------- */
  $all("[data-demo-form]").forEach(function (form) {
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var msg = form.getAttribute("data-demo-form") || "Thanks!";
      form.innerHTML = '<div class="form-success">' + escapeHtml(msg) + "</div>";
    });
  });

  // initial cart hydrate
  refreshCart();
})();
